import type {FC} from 'react';

import {Observer} from 'mobx-react';
import {useTheme} from 'styled-components';

import type {Ref as TextInputRef} from '../../../../../../../../uikit/TextInput/types';
import type {AddWeightStore} from '../../store';

import * as S from './styles';

type Props = {
  inputRef?: React.RefObject<null | TextInputRef>;
  onRequestSubmit?: () => void;
  store: AddWeightStore;
};

export const WeightInput: FC<Props> = ({inputRef, onRequestSubmit, store}) => {
  const theme = useTheme();

  return (
    <Observer>
      {() => (
        <S.Container>
          <S.Half align="right">
            <S.Input
              autoFocus
              inputMode="numeric"
              nativeProps={{
                selectionColor: theme.color.v3.static.accent.trackers,
                textAlign: 'right',
              }}
              onChange={store.onWeightChange}
              onSubmit={onRequestSubmit}
              ref={inputRef}
              value={store.field.value}
            />
          </S.Half>
          <S.Half align="left">
            <S.Unit>{store.currentUnitLabel}</S.Unit>
          </S.Half>
          {store.field.error ? (
            <S.InputError>{store.field.error}</S.InputError>
          ) : null}
        </S.Container>
      )}
    </Observer>
  );
};
